export { default as ReztoLogo } from "./resto_logo.svg";
export { default as ScheduleTimeIcon } from "./pace.svg";
export { default as TimeIcon } from "./avg_pace.svg";
